export const LOGIN_SUCCESS = 'LoginSuccess';
export const COMPLETE_REGISTRATION = 'CompleteRegistration';
export const VIEW_CONTENT = 'ViewContent';

export const PURCHASE_CHECK_OUT_PAGE_ENTER = 'PURCHASE_CHECK_OUT_PAGE_ENTER';
export const PURCHASE_INITIAL_CHECKOUT = 'PURCHASE_INITIAL_CHECKOUT';
export const PURCHASE_SUCCESS = 'PURCHASE_SUCCESS';
export const PURCHASE_SUCCESS_COURSE = 'PURCHASE_SUCCESS_COURSE';
export const PURCHASE_SUCCESS_REGULAR_CLASS = 'PURCHASE_SUCCESS_REGULAR_CLASS';
export const PURCHASE_SUCCESS_GROUP_PASS = 'PURCHASE_SUCCESS_GROUP_PASS';
export const PRODUCT_DETAIL = 'ProductDetail';
export const PRODUCT_CHECKOUT = 'ProductCheckout';
export const PRODUCT_PURCHASE = 'ProductPurchase';
export const SHARE_REFERRAL_URL = 'ShareReferralUrl';

// redeem code
export const PURCHASE_DISCOUNT_CODE_FIELD_INPUT =
  'PURCHASE_DISCOUNT_CODE_FIELD_INPUT';
export const PURCHASE_DISCOUNT_CODE_APPLY_CLICK =
  'PURCHASE_DISCOUNT_CODE_APPLY_CLICK';

// instructor profile
export const NAV_COURSE_ALL_INSTRUCTOR_CLICK =
  'NAV_COURSE_ALL_INSTRUCTOR_CLICK';
export const NAV_RC_ALL_INSTRUCTOR_CLICK = 'NAV_RC_ALL_INSTRUCTOR_CLICK';

// onboarding
export const ONBOARDING_MAIN_PAGE_ENTER = 'ONBOARDING_MAIN_PAGE_ENTER';
export const ONBOARDING_CREATEACCOUNT_CLICK = 'ONBOARDING_CREATEACCOUNT_CLICK';
export const ONBOARDING_CREATEACCOUNT_EMAILVERIFIED_CLICK =
  'ONBOARDING_CREATEACCOUNT_EMAILVERIFIED_CLICK';
export const ONBOARDING_SIGNUP_CHECK_EMAIL_PAGE_ENTER =
  'ONBOARDING_SIGNUP_CHECK_EMAIL_PAGE_ENTER';
export const ONBOARDING_PHONE_VERIFY_CLICK = 'ONBOARDING_PHONE_VERIFY_CLICK';
export const ONBOARDING_SETUP_PHONE_CLICK = 'ONBOARDING_SETUP_PHONE_CLICK';
export const EVENT_COMPLETED_REGISTRATION = 'EVENT_COMPLETED_REGISTRATION';

// social widget event
export const WIDGET_CLICK = 'WIDGET_CLICK';
export const WIDGET_CTA_CLICK = 'WIDGET_CTA_CLICK';

export const HOME_DOWNLOAD_CLICK = 'HOME_DOWNLOAD_CLICK';



// WEBPACK FOOTER //
// ./app/constants/gtmEvents.js